import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_RELATORIOS_DEMANDAS = `${modulo.GESTAO_DE_DEMANDAS}/relatorios/demandas/`
const URL_RELATORIOS_USUARIOS = `${modulo.GESTAO_DE_DEMANDAS}/relatorios/usuarios/`
const URL_RELATORIOS_QUANTITATIVO = `${modulo.GESTAO_DE_DEMANDAS}/relatorios/quantitativo`

const actions = {
  findDemandasTodas ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_RELATORIOS_DEMANDAS}todas`
    })
  },

  findDemandasAseremFeitas ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_RELATORIOS_DEMANDAS}aSeremFeitas`
    })
  },

  findDemandasEmAndamento ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_RELATORIOS_DEMANDAS}emAndamento`
    })
  },

  findDemandasAtrasadas ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_RELATORIOS_DEMANDAS}atrasadas`
    })
  },

  findDemandasAvencer ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_RELATORIOS_DEMANDAS}aVencer`
    })
  },

  findDadosGraficoUsuarioPainel ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_RELATORIOS_USUARIOS}paineis`
    })
  },

  findDadosGraficoUsuarioDemandas ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_RELATORIOS_USUARIOS}demandas`
    })
  },

  findQuantitativo ({ commit }) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: URL_RELATORIOS_QUANTITATIVO
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/demandas/relatorios.js